var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2525 5.03333C15.9712 3.61476 15.2037 2.33738 14.0812 1.41937C12.9586 0.501361 11.5506 -0.000326869 10.0976 1.59781e-07C7.67753 1.59781e-07 5.57566 1.36667 4.52891 3.36667C3.29813 3.49903 2.15991 4.07934 1.33297 4.9961C0.506023 5.91286 0.0486843 7.1014 0.0488282 8.33333C0.0488282 11.0917 2.30143 13.3333 5.07322 13.3333H15.9594C18.2706 13.3333 20.1464 11.4667 20.1464 9.16667C20.1464 6.96667 18.4297 5.18333 16.2525 5.03333ZM11.7724 7.5V10.8333H8.42281V7.5H5.91062L9.80452 3.625C9.972 3.45833 10.2316 3.45833 10.3991 3.625L14.2846 7.5H11.7724Z",
    fill: "#F3EFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/Icon_Upload.d447627397899ffc732bbc97fcbfe576.svg";
export { ForwardRef as ReactComponent };